// frontend_react/src/services/cartApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const setCartMode = (payload, { companyUuid } = {}) =>
  api.post("/cart/mode", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const fetchCart = ({ companyUuid } = {}) =>
  api.get("/cart/", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const addCartItem = (itemUuid, qty = 1, options = {}) =>
  api.post(
    `/cart/add/${itemUuid}`,
    {
      quantity: qty,
      source: options.source ?? "activity",
      activity_uuid: options.activity_uuid ?? null,
      activity_type: options.activity_type ?? null,
    },
    {
      headers: buildCompanyScopeHeaders(options.companyUuid),
    }
  );

export const decrementCartItem = (uuid, { companyUuid } = {}) =>
  api.post(
    `/cart/decrement/${uuid}`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const removeCartItem = (uuid, { companyUuid } = {}) =>
  api.post(
    `/cart/delete/${uuid}`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const clearCart = ({ companyUuid } = {}) =>
  api.post(
    "/cart/clear",
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const checkoutCart = ({
  payments = [],
  table_number,
  covers,
  client_uuid = null,
  companyUuid = null,
}) => {
  const payload = {
    payments,
    client_uuid,
  };
  if (table_number != null) payload.table_number = table_number;
  if (covers != null) payload.covers = covers;

  return api.post("/cart/checkout", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });
};

export const fetchPendingCarts = ({ companyUuid } = {}) =>
  api.get("/cart/pending", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const createPendingCart = ({
  items = {},
  tableId,
  covers,
  modeVente = "restaurant",
  companyUuid = null,
}) =>
  api.post(
    "/cart/pending/create",
    {
      items,
      mode_vente: modeVente,
      table_number: tableId,
      covers,
    },
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const recallPendingCart = (uuid, { companyUuid } = {}) =>
  api.post(
    `/cart/pending/recall/${uuid}`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const deletePendingCart = (uuid, { companyUuid } = {}) =>
  api.delete(`/cart/pending/delete/${uuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const transferCart = () => {
  throw new Error("Endpoint manquant côté backend: POST /api/cart/transfer");
};

export const openCashSession = (mode, { companyUuid } = {}) =>
  api.post(
    "/certifications/open",
    { mode },
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const closeCashSession = (uuid, { companyUuid } = {}) =>
  api.post(
    `/certifications/close/${uuid}`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );